import React, { useEffect } from 'react';
import { useImmer } from 'use-immer';
import _ from 'lodash';
import MetaTags from 'react-meta-tags';

import images from '../../images/images';
import useMomBaby from '../../api/mom-baby-service';
import useRouter from '../../hooks/use-router';
import { ListPopUp, ListContainer } from '../../components/custom-list';

const WarmRecords = () => {
  const [state, produce] = useImmer({
    ...location.state,
    isFirst: true,
    loading: true,
    list: null,
    detail: null,
    defaultKeywords: null,
    description: '國泰產後護理之家暖心紀錄，提供名人、網紅，以及素人媽咪入住體驗、分享、推薦與開箱相關資訊，豐富內容立即觀看！',
    keywords:
      '國泰,國泰產後,國泰產後護理之家,產後護理之家,產後護理,坐月子,月子中心,台北 產後護理之家,台南 產後護理之家,松山區 月子中心,台北 月子中心,中西區 月子中心,台南 月子中心,月子中心 推薦,產後護理之家 推薦,月子中心 評價,產後護理之家 評價,月子中心 比較,大寶 月子中心,二寶 月子中心',
  });

  const { isFirst, list, loading, detail, defaultKeywords, keywords, description } = state;
  const {
    query: { id },
    push,
  } = useRouter();

  const { getWarmRecords, getWarmRecordsDetail } = useMomBaby();

  useEffect(() => {
    getList();
    produce((draft) => {
      draft.defaultKeywords = keywords;
    });
  }, []);

  useEffect(() => {
    if (!id) return;
    getDetail(id);
  }, [id]);

  const getList = async () => {
    produce((draft) => void (draft.loading = true));
    const { status, message, result } = await getWarmRecords();
    produce((draft) => void (draft.loading = false));
    if (status == '1') {
      produce((draft) => void (draft.list = result));
    }
  };

  const getDetail = async (id) => {
    if (!!detail) return;
    produce((draft) => void (draft.loading = true));
    const { status, message, result } = await getWarmRecordsDetail(id);
    produce((draft) => void (draft.loading = false));
    if (status == '1') {
      produce((draft) => {
        draft.detail = result;
        draft.description = result.description
        draft.keywords = result.keywords;
      });
    }
  };

  return (
    <div>
      <MetaTags>
        <title>暖心紀錄｜名人、網紅等媽媽入住分享、推薦與開箱｜國泰產後護理之家</title>
        <meta
          name="description"
          content={description}
        />
        <meta name="keywords" content={keywords} />
      </MetaTags>
      <ListContainer
        backgroundImage={images.background_01_b}
        title="暖心紀錄"
        subtitle="入住分享與活動花絮"
        isFirst={isFirst}
        loading={loading}
        datas={_.map(list, (o) => ({
          id: o.id,
          title: o.title,
          image: o.imagePath,
          intro: o.briefIntro,
          tab: '暖心紀錄',
        }))}
      />
      {detail && !loading && (
        <ListPopUp
          isShowDialog={!!detail}
          overlayAction={() => {
            produce((draft) => {
              draft.detail = null;
              draft.description = null;
              draft.keywords = defaultKeywords;
            });
            push('/warm-records');
          }}
          detail={detail}
        />
      )}
    </div>
  );
};

export default WarmRecords;
